import { NgStyle } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-color-select',
  standalone: true,
  imports: [NgStyle],
  templateUrl: './select.component.html',
  styleUrl: './select.component.css',
})
export class SelectColorComponent {
  selectedValue: string | undefined;
  dropdownOpen = false;
  @Input() options: { value: any; viewValue: string }[] = [
    { value: 'green', viewValue: 'Green' },
    { value: 'blue', viewValue: 'Blue' },
    { value: 'yellow', viewValue: 'Yellow' },
    { value: 'red', viewValue: 'Red' },
    { value: 'white', viewValue: 'White' },
    { value: 'black', viewValue: 'Black' },
  ];

  @Output() selectChange = new EventEmitter();

  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }

  closeDropdown() {
    this.dropdownOpen = false;
  }

  selectOption(option: { value: string; viewValue: string }) {
    this.selectedValue = option.viewValue;
    this.selectChange.emit(option.value);
  }

  onKeydown(event: KeyboardEvent) {
    if (event.key === 'Enter' || event.key === ' ') {
      this.toggleDropdown();
      event.preventDefault();
    }
  }

  onOptionKeydown(
    event: KeyboardEvent,
    option: { value: string; viewValue: string }
  ) {
    if (event.key === 'Enter' || event.key === ' ') {
      this.selectOption(option);
      event.preventDefault();
    }
  }
}
